// Globals
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Store
import { useAppDispatch, useAppState } from '@/store';
import { getGoogleMerchantSyncRuns } from '../../feature';

// Modules
import { selectChannel } from '@/modules/Channels';
import { useGetGoogleMerchantSettings } from '@/modules/MerchantSettings/hooks';

//Components
import { GoogleMerchantSyncModal, GoogleMerchantSyncTable } from '../../components';
import { StyledButton, StyledContainer, StyledPagination } from './MerchantSyncContainerStyles';

// Helpers
import { useBoolean } from '@/hooks';
import { useGetGoogleMerchantSyncRuns } from '../../hooks';

const MerchantSyncContainer: FC = () => {
  const { t } = useTranslation(['common']);
  const dispatch = useAppDispatch();
  const currentChannel = useAppState(selectChannel);

  const { merchantSettings } = useGetGoogleMerchantSettings(currentChannel?.id);
  const { syncRuns, pagination, isLoading } = useGetGoogleMerchantSyncRuns(currentChannel?.slug);
  const { value: isSyncModalOpen, toggle: handleToggleSyncModal } = useBoolean();

  const handlePageChange = (page: number) => {
    if (!currentChannel) return;

    dispatch(getGoogleMerchantSyncRuns({ page, pageSize: 10, channelSlug: currentChannel?.slug }));
  };

  return (
    <>
      <StyledContainer>
        <StyledButton disabled={!merchantSettings} onClick={handleToggleSyncModal} type="primary" size="small">
          {t('btn_run_sync')}
        </StyledButton>
        <GoogleMerchantSyncTable isLoading={isLoading} syncRuns={syncRuns} />
        <StyledPagination
          disabled={isLoading}
          total={pagination?.total ?? 0}
          current={pagination?.page ?? 1}
          pageSize={pagination?.pageSize ?? 10}
          onChange={handlePageChange}
          hideOnSinglePage
        />
      </StyledContainer>
      <GoogleMerchantSyncModal isOpen={isSyncModalOpen} onClose={handleToggleSyncModal} />
    </>
  );
};

export default MerchantSyncContainer;
